import { DefaultDashboardSelection } from '@models/businesses';

export class Filter {
	static readonly type = '[dashboard-data] filter';
	constructor(public filter: DefaultDashboardSelection) {}
}

export class SetDate {
	static readonly type = '[dashboard-data] set date';
	constructor(public date: number | string) {}
}

export class Search {
	static readonly type = '[dashboard-data] search';
	constructor(
		public payload: { date: number; filter: DefaultDashboardSelection },
	) {}
}
